import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const SareeIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 512 512">
    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="currentColor" strokeWidth="50">
      <path d="M1505 5103 c-290 -62 -520 -294 -579 -585 -13 -63 -16 -153 -16 -488
      l0 -410 374 0 373 0 72 -359 71 -358 -60 -102 c-216 -364 -370 -767 -455
      -1196 -51 -253 -66 -407 -72 -722 l-6 -283 152 0 151 0 0 -300 0 -300 1051 0
      1051 0 -5 698 c-5 710 -9 808 -51 1112 l-14 95 77 80 c325 339 533 798 581
      1284 5 57 10 344 10 637 0 584 -3 620 -59 754 -72 173 -228 329 -401 401 -127
      53 -185 59 -588 59 l-369 0 -223 -247 c-122 -137 -226 -249 -230 -251 -15 -6
      -114 123 -157 205 -23 43 -58 126 -77 183 l-35 105 -248 2 c-189 1 -265 -2
      -318 -14z m378 -346 c39 -89 137 -238 202 -306 l54 -57 -132 -147 c-72 -81
      -134 -144 -138 -139 -3 4 -19 71 -34 150 -27 137 -29 143 -50 138 -12 -3 -71
      -15 -131 -26 -60 -12 -116 -23 -125 -26 -14 -4 -11 -29 26 -214 l42 -210 -193
      0 -194 0 0 245 c0 140 5 267 11 297 17 81 74 182 135 237 98 90 188 119 374
      120 l126 1 27 -63z m1667 53 c25 -6 58 -16 73 -22 l29 -11 -798 -798 c-439
      -439 -799 -797 -801 -795 -4 3 -101 486 -105 520 -2 19 95 133 487 570 l490
      545 290 0 c160 0 310 -4 335 -9z m347 -340 c8 -37 13 -135 13 -302 l0 -248
      -194 0 -193 0 37 186 38 186 133 134 c148 149 142 147 166 44z m-773 -1014
      l-87 -436 -163 0 -164 0 0 192 0 193 247 247 c136 136 249 246 251 244 2 -2
      -36 -200 -84 -440z m786 47 c-1 -432 -118 -796 -368 -1145 -30 -43 -58 -78
      -62 -78 -3 0 -12 30 -20 68 -11 57 -40 166 -128 483 l-16 55 74 367 73 367
      223 0 224 0 0 -117z m-1500 -1503 l0 -1100 -451 0 -452 0 7 123 c34 598 197
      1145 488 1632 51 84 87 127 231 273 95 94 173 172 174 172 2 0 3 -495 3 -1100z
      m676 600 c95 -328 164 -703 205 -1115 6 -60 13 -352 16 -648 l5 -537 -751 0
      -751 0 0 150 0 150 450 0 450 0 0 1060 0 1060 171 -2 172 -3 33 -115z"/>
    </g>
  </SvgIcon>
);

export default SareeIcon;